export default __webpack_public_path__ + "c397c96021f06bf403f33d3cdf636294.png";